<h4 class="font-bold" style="font-size: 18px">{{ "global.shopList" | translate }}</h4>
<p-card>
  <form [formGroup]="form">
    <div class="grid">
      <div class="lg:col-3 md:col-4 sm:col-4">
        <p-select
          [formControlName]="fields[0].name"
          [options]="fields[0].options"
          [optionLabel]="fields[0].optionLabel"
          (ngModelChange)="filterGlobal($event, 'canal')"
          class="w-full">
          <ng-template let-option pTemplate="item">
            {{ option[fields[0].optionLabel] | translate }}
          </ng-template>
          <ng-template let-selectedItem pTemplate="selectedItem">
            @if (selectedItem) {
              <p class="inline line-height-1">{{ fields[0].label | translate }} - </p>
              <p class="inline font-bold line-height-1">{{ selectedItem.channelName | translate}}</p>
            }
          </ng-template>
        </p-select>
      </div>
      <div class="lg:col-3 md:col-4 sm:col-4">
        <!-- <input
          type="text"
          pInputText
          [formControlName]="fields[1].name"
          (input)="filterGlobal(dt2, $event)"
          [placeholder]="fields[1].placeholder"
          class="w-full block" /> -->

        <p-autoComplete
          multiple
          [typeahead]="false"
          [formControlName]="fields[1].name"
          [placeholder]="fields[1].placeholder | translate"
          (keydown)="onFilterKeydown($event, fields[1])"
          (paste)="onFilterPaste($event, fields[1])"
          (onUnselect)="filterGlobal($event)"
          class="w-full block" />
      </div>

      <div class="lg:col-6 md:col-4 sm:col-4 text-right">
        <p-button [outlined]="true" (click)="openFilterModal()">
          <i class="pi pi-filter"></i>
          @if (tags.length > 0) {
            <p-badge [value]="tags.length" severity="info" class="flex align-content-center filter-badge" />
          }
          <span class="pl-2 font-semibold">{{ "global.filter" | translate }}</span>
        </p-button>
      </div>

      @if (tags.length > 0) {
        @for (tag of tags; track $index) {
          <p-tag class="ml-3 mb-1">
            <span>{{tag.header | translate}}{{ ": " }} 
              @if (!tag.isMultiple) {
                @if (tag.isLengthOnly) {
                  {{ tag.valueString }} {{ 'global.selectedElements' | translate }}
                } @else {
                  {{ tag.valueString | translate }}
                }
              } @else {
                @for (item of tag.valueString; track $index) {
                  {{ item | translate }}{{ $index < tag.valueString.length - 1 ? ', ' : '' }}
                }
              }
            </span>
            <i class="pi pi-times-circle ml-1 cursor-pointer" (click)="removeFilter(tag.name)"></i>
          </p-tag>
        }
        <span
          style="cursor: pointer; text-decoration: underline; color: #aaa"
          class="pl-3 flex align-items-center"
          (click)="clearFilters()"
          >{{'global.removeFilter' | translate}}</span
        >
      }
    </div>
  </form>
  @if (selectedShops ?.length > 0) {
    <div class="col-12 flex align-items-center">
      {{ selectAll ? totalRecords : selectedShops.length }} {{ "shop.selectedShops" | translate }}
      <p-button
        [text]="true"
        (click)="selectAllShops()"
        label="{{ 'shop.selectAllShops' | translate }}"></p-button>
        <p-button
        [text]="true"
        (click)="removeSelection()"
        severity="danger"
        label="{{ 'buttons.removeSelection' | translate }}"></p-button>
      <p-button
        [text]="true"
        (click)="exportShops()"
        [disabled]="disabledExportButton"
        icon="pi pi-upload font-semibold"
        label="{{ 'buttons.export' | translate }}"></p-button>
    </div>
  }
</p-card>
<div class="h-1rem"></div>
<div style="margin-top: 20px">
  <p-table
    #dt2
    class="table-shadow"
    [value]="shops"
    [scrollable]="true"
    [(selection)]="selectedShops"
    [selectionPageOnly]="true"
    selectionMode="single"
    [rowHover]="true"
    scrollHeight="500px"
    [paginator]="true"
    [rows]="rows"
    [lazy]="true"
    (onLazyLoad)="onLazyLoad($event)"
    [loading]="loading"
    (selectionChange)="selectionChange()"
    [showCurrentPageReport]="true"
    [currentPageReportTemplate]="'table.currentPageReportTemplate' | translate"
    [totalRecords]="totalRecords"
    [rowsPerPageOptions]="[50, 100, 200]"
    [tableStyle]="{ 'min-width': '50rem' }"
    [globalFilterFields]="['shopName', 'shopCode', 'legalEntityName']">
    <ng-template pTemplate="header">
      <tr>
        <th class="w-4rem" id="table-checkbox"><p-tableHeaderCheckbox /></th>
        @for (header of headers; track $index) {
          <th [pSortableColumn]="header.sortColumn || header.id" style="font-size: 0.9rem" [id]="header.id">
            <span>{{ header.value | translate }}</span>
            @if (header.tooltip) {
              <i
                class="pi pi-info-circle pl-2 color-link-primary vertical-align-top"
                pTooltip="{{ header.tooltip | translate }}" tooltipPosition="bottom"></i>
            }
            <p-sortIcon [field]="header.id" class="ml-1"/>
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-shop>
      <tr>
        <td>
          <p-tableCheckbox [value]="shop" />
        </td>
        @for (header of headers; track $index) {
          <td (click)="rowClick(shop)">
            @if (header.type == "tag") {
              @if (shop[header.id] == "1") {
                <p-tag severity="success">{{ "global.authorized" | translate }}</p-tag>
              } @else {
                <p-tag severity="danger">{{ "global.notAuthorized" | translate }}</p-tag>
              }
            } @else if (header.type == "status") {
              <p-tag [severity]="getSeverity(shop[header.id].statusCode)">{{
                shop[header.id].statusCode | translate
              }}</p-tag>
            } @else if (header.type == "date") {
              {{ shop[header.id] | date: "dd/MM/yyyy HH:mm" }}
            } @else if (header.type == "score") {
              @if (shop[header.id]) {
                @if (shop[header.id] < 40) {
                  <p-tag severity="danger">{{ shop[header.id] }}</p-tag>
                } @else if (shop[header.id] < 70) {
                  <p-tag severity="secondary">{{ shop[header.id] }}</p-tag>
                } @else {
                  <p-tag severity="success">{{ shop[header.id] }}</p-tag>
                }
              }
            } @else {
              {{ shop[header.id] }}
            }
          </td>
        }
      </tr>
    </ng-template>
  </p-table>
</div>
